import React from 'react'

import './loadingSendWithScreenLock.css'
const LoadingSendWithScreenLock =()=>{

    return(
        <div className="fixed z-20 top-0 left-0 right-0 bottom-0 w-screem h-screen bg-gray-600 bg-opacity-0">
            <div className="contentLoadData2">
                <div className="loadingDataLeft2">
                </div>
            </div>
        </div>
    )
}

export default LoadingSendWithScreenLock;